/**
 * The line under a follower's name: their title and firm. A part that only repeats the person's own
 * name (a solo investor whose firm is named after them) says nothing new, so it is left out.
 */
export function followerDetail(person: {
  name: string | null
  title: string | null
  firmName: string | null
}): string {
  const own = person.name?.trim().toLowerCase() ?? ''
  return [person.title, person.firmName]
    .map((part) => part?.trim())
    .filter((part): part is string => !!part && part.toLowerCase() !== own)
    .join(', ')
}
